import axios from "axios";
import { DateTime } from "luxon";
import type { CalendarDayOut } from "@/pages/human-resources/time-management/endpoints/calendar/inout/CalendarDayOut.ts";
import { LEGACY_TIME_ZONE } from "@/shared/utils/LegacyDates.ts";

export async function readCalendarDays(
  siteId: string,
  startDate: Date,
  endDate: Date,
): Promise<CalendarDayOut[]> {
  const start = DateTime.fromJSDate(startDate, { zone: LEGACY_TIME_ZONE });
  const end = DateTime.fromJSDate(endDate, { zone: LEGACY_TIME_ZONE });
  const { data } = await axios.post<CalendarDayOut[]>(
    `/api/calendrier/${siteId}/listDays`,
    {
      startDate: start.toISO(),
      endDate: end.toISO(),
    },
  );
  return data;
}

export const calendarDayQueryKey = {
  all: ["schedule_analysis_calendar_day"] as const,
  forSiteAndDateRange: (
    siteId: string,
    start: Date | undefined,
    end: Date | undefined,
  ) => [...calendarDayQueryKey.all, siteId, start, end] as const,
};
